app.component("legalAgreementAdminConsole", {
    templateUrl: "app/src/js/components/admin/legalAgreementConsole.html",
    controller: "legalAgreementAdminController"
});

app.controller("legalAgreementAdminController", [
    "$scope",
    "LegalAgreementAPI",
    "NgTableParams",
    "$window",
    function ($scope, LegalAgreementAPI, NgTableParams, $window) {

        // State Management
        $scope.API = LegalAgreementAPI;
        $scope.documents = [];
        $scope.selectedDocument = null;
        $scope.formDisplay = false;
        $scope.isVersioning = false; // True if updating an existing document
        $scope.formData = {};

        // Dropdown Options
        $scope.statusOptions = [
            { name: "Active", value: "ACTIVE" },
            { name: "Archived", value: "ARCHIVED" }
        ];

        /**
         * Fetch all active legal agreements on load
         */
        $scope.fetchDocuments = function () {
            $scope.API.isProcessing = true;
            $scope.API.getAllActiveDocuments().then(function (resp) {
                $scope.documents = resp.data || [];
                $scope.tableParams = new NgTableParams(
                    { page: 1, count: 10 },
                    { dataset: $scope.documents }
                );
            }).catch(function (error) {
                console.error("Error fetching documents:", error && error.status);
                alert("Failed to load documents.");
            }).finally(function () {
                $scope.API.isProcessing = false;
            });
        };

        /**
         * Table Row Selection
         */
        $scope.selectDocument = function (document) {
            if ($scope.selectedDocument && $scope.selectedDocument.document_id === document.document_id) {
                $scope.selectedDocument = null; // Deselect if clicked again
            } else {
                $scope.selectedDocument = document;
            }
        };

        /**
         * Open form to create a completely new document
         */
        $scope.openCreateForm = function () {
            $scope.isVersioning = false;
            $scope.formData = {
                document_name: "",
                escaped_html_content: ""
                // Removed status field per instructions
            };
            $scope.formDisplay = true;
        };

        /**
         * Open form to create a new version of the selected document
         */
        $scope.openVersionForm = function () {
            if (!$scope.selectedDocument) return;
            $scope.isVersioning = true;
            $scope.formData = {
                document_name: $scope.selectedDocument.document_name,
                escaped_html_content: $scope.selectedDocument.escaped_html_content
                // Removed status field per instructions
            };
            $scope.formDisplay = true;
        };

        /**
         * Submit the form (handles both Create and Update)
         */
        $scope.submitDocument = function (form) {
            // Check the passed-in form object
            if (form && form.$invalid) {
                return;
            }

            $scope.API.isProcessing = true;
            let request = $scope.isVersioning
                ? $scope.API.updateDocumentVersion($scope.selectedDocument.document_id, $scope.formData)
                : $scope.API.createDocument($scope.formData);

            request.then(function (resp) {
                $scope.closeForm();
                $scope.fetchDocuments(); // Refresh table
            }).catch(function (error) {
                console.error("Error saving document:", error && error.status);
                alert("Failed to save document.");
            }).finally(function () {
                $scope.API.isProcessing = false;
            });
        };

        $scope.closeForm = function () {
            $scope.formDisplay = false;
            $scope.selectedDocument = null;
            $scope.formData = {};
        };

        $scope.goBack = function () {
            $window.history.back();
        };

        // Initialize
        $scope.fetchDocuments();
    }
]);